import React, { SVGAttributes } from 'react';

export function DoctorOutlineIcon(props: SVGAttributes<unknown>): JSX.Element {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 49' fill='none' width='48' height='49' {...props}>
      <title>Doctor Outline</title>
      <path
        d='M23.8722 18.555C27.2425 18.555 29.9747 15.8228 29.9747 12.4524C29.9747 9.08197 27.2425 6.34973 23.8722 6.34973C20.5018 6.34973 17.7695 9.08197 17.7695 12.4524C17.7695 15.8228 20.5018 18.555 23.8722 18.555Z'
        stroke='black'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12.5391 29.8886C12.5391 26.8826 13.7331 24 15.8585 21.8746C17.984 19.7491 20.8667 18.5551 23.8725 18.5551C26.8784 18.5551 29.761 19.7491 31.8864 21.8746C34.012 24 35.206 26.8826 35.206 29.8886'
        stroke='black'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M17.7695 26.7392H22.8043'
        stroke='black'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M20.2871 24.2216V29.2564'
        stroke='black'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M30.622 2.56531H37.3712C39.2348 2.56531 40.7456 4.07617 40.7456 5.93989V43.0602C40.7456 44.9238 39.2348 46.4348 37.3712 46.4348H10.3746C8.51086 46.4348 7 44.9238 7 43.0602V5.93989C7 4.07617 8.51086 2.56531 10.3746 2.56531H17.1237'
        stroke='black'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M21.3418 38.9122H26.4036'
        stroke='black'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
